import { SubscriptionItemModel } from "../../entities/billing";
import { BaseDataRepository } from "../BaseDataRepository";

export class SubscriptionItemRepo extends BaseDataRepository<SubscriptionItemModel>  {
  protected baseUrl = 'subscriptionitem';
}

export default SubscriptionItemRepo;
